module.exports = __webpack_public_path__ + "img/leaves-pattern.0f815a0e.png";